import React from "react";

export const Chart = () => (
  <svg viewBox="0 0 512 512">
    <path
      d="M274.13,120.66c0,32.31-0.08,64.61,0.03,96.92c0.06,17.58,2.93,20.43,20.55,20.45
	c64.21,0.07,128.41,0.01,192.62,0.04c19.44,0.01,25.33,7.04,24.6,26.77c-4.56,122.55-93.06,218.5-203.67,242.46
	C169.98,537.25,27.34,441.97,3.85,302.39C-20.63,156.97,74.13,25.34,219.76,2.72c10.73-1.67,21.67-2.34,32.53-2.69
	c14.22-0.47,21.71,6.93,21.78,21.3C274.25,54.44,274.13,87.55,274.13,120.66z"
    />
    <path
      d="M299.04,108.09c0-27.42-0.01-54.85,0-82.27c0-20.1,3.61-23.9,23.48-20.96
	c86.72,12.84,145.54,60.38,175.54,142.92c5.79,15.93,8.87,32.59,9.79,49.59c0.56,10.47-3.76,15.85-14.7,15.83
	c-59.69-0.1-119.37-0.11-179.06,0.01c-10.8,0.02-15.2-5.05-15.13-15.59C299.17,167.77,299.04,137.93,299.04,108.09z"
    />
  </svg>
);
